import { createContext, useContext } from 'react'
import { type ViewCallingStore } from '../store/ViewCallingStore'

export const ViewCallingContext = createContext<ViewCallingStore | null>(null)

export const useViewCallingContext = () => {
  const context = useContext(ViewCallingContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ViewCallingContext')

  return context
}
